import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import {  Observable, map } from "rxjs";
import { environment } from '../../../environments/environment';
import {ICompany} from "../models/ICompany";
import { ApiResponse } from '../models/ApiResponse';

@Injectable({ providedIn: 'root' })
export class CompanyService {
    constructor(private _http: HttpClient) {}

    getAllCompanies(): Observable<ICompany[]> {
        return this._http.get<ApiResponse<ICompany[]>>(`${environment.apiUrl}/api/companies`).pipe(
            map(res=>res.data)
        );
    }

    getAllCompaniesForAdmin(): Observable<ICompany[]> {
        return this._http.get<ApiResponse<ICompany[]>>(`${environment.apiUrl}/api/companies/admin`).pipe(
            map(res=>res.data)
        );
    }

    getCompaniesByFilters(filters: any): Observable<{ data: ICompany[]; total: number }> {
        let params = new HttpParams();

        Object.keys(filters).forEach(key => {
        if (
            filters[key] !== null &&
            filters[key] !== undefined &&
            filters[key] !== ''
        ) {
            params = params.set(key, filters[key]);
        }
        });

        return this._http.get<{ data: ICompany[]; total: number }>(`${environment.apiUrl}/api/companies/search`,{ params });
    }

    getFavoriteCompanies(filters: any): Observable<{ data: ICompany[], total: number }> {
        let params = new HttpParams();
        Object.keys(filters).forEach(key => {
            if (filters[key] !== null && filters[key] !== undefined && filters[key] !== '') {
            params = params.set(key, filters[key]);
            }
        });
        return this._http.get<{ data: ICompany[], total: number }>(`${environment.apiUrl}/api/companies/favorites`, { params });
    }

    getCompanyById(companyId: string, shouldCount: boolean = false) : Observable<ICompany> {
        let headers = new HttpHeaders();
        if (shouldCount) {
            headers = headers.set('x-count-view', 'true');
        }
        return this._http.get<ApiResponse<ICompany>>(`${environment.apiUrl}/api/companies/${companyId}`, { headers }).pipe(
            map(res=>res.data)
        );
    }

    uploadLogo(companyId:string, file: File): Observable<string> {
        const formData = new FormData();
        formData.append('logo', file);
    
        return this._http.post<ApiResponse<string>>(`${environment.apiUrl}/api/companies/${companyId}/logo`, formData).pipe(
            map(res => res.data)
        );
    }

    editCompany(companyId: string, companyData: Partial<ICompany>) : Observable<ICompany> {
        return this._http.patch<ApiResponse<ICompany>>(`${environment.apiUrl}/api/companies/${companyId}`, companyData).pipe(
            map(res=>res.data)
        );
    }

    rateCompany(companyId: string, scores: any): Observable<any> {
        return this._http.patch<ApiResponse<ICompany>>(`${environment.apiUrl}/api/companies/${companyId}/rate`, { scores }).pipe(
            map(res => res.data)
        );
    }

    createCompany(companyForm: any) : Observable<{data:ICompany, role: string}> {
        return this._http.post<ApiResponse<{data:ICompany, role: string}>>(`${environment.apiUrl}/api/companies/create`, companyForm).pipe(
            map(res=>res.data)
        );
    }

    deleteCompany(companyId: string): Observable<void> {
        return this._http.delete<ApiResponse<void>>(`${environment.apiUrl}/api/companies/${companyId}`).pipe(
            map(res => res.data)
        );
    }

    addGalleryImage(companyId: string, formData: FormData): Observable<any> {
        return this._http.post(`${environment.apiUrl}/api/companies/${companyId}/gallery`, formData);
    }

    removeGalleryImage(companyId: string, imageUrl: string): Observable<any> {
        const filename = imageUrl.split('/').pop();
        return this._http.delete(`${environment.apiUrl}/api/companies/${companyId}/gallery/${filename}`);
    }
}
